// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"50de8bf8","564":"bd350385"}[chunkId] + ".chunk.css";
};